import { defineStore } from 'pinia';
import _ from 'lodash';

import MetaPixelApi from '@/extensions/marketing/store/api/metaPixel';
import { useSetupStore } from '@/stores';

const defaultForm = {
    id: null,
    pixel_id: '',
    access_token: '',
    test_event_code: '',
    is_enabled: false,
    send_server_events: true,
    track_page_view: true,
    track_view_content: true,
    track_add_to_cart: true,
    track_initiate_checkout: true,
    track_search: true,
    track_purchase: true,
    cms: null,
};

const defaultRules = {
    pixel_id: 'required',
};

const defaultUi = {
    form: {
        initialized: false,
        validateOnEnter: false,
    },
};

export const useMarketingMetaPixelStore = defineStore('marketingMetaPixel', {
    state: () => ({
        loading: true,
        form: _.cloneDeep(defaultForm),
        rules: _.cloneDeep(defaultRules),
        ui: _.cloneDeep(defaultUi),
    }),

    getters: {
        formInitialized: (state) => state.ui.form.initialized,
        formValidateOnEnter: (state) => state.ui.form.validateOnEnter,
    },

    actions: {
        setForm(data) {
            this.form = _.cloneDeep(data);
        },

        resetUI() {
            this.ui.form.initialized = false;
            this.ui.form.validateOnEnter = false;
        },

        setFormInitialized(flag) {
            this.ui.form.initialized = flag;
        },

        setFormValidateOnEnter(flag) {
            this.ui.form.validateOnEnter = flag;
        },

        async fetch() {
            const setupStore = useSetupStore();
            const cms = setupStore.activeCms;
            if (!cms) return;

            this.loading = true;
            return MetaPixelApi.fetch(cms.id)
                .then(data => {
                    const fetched = _.cloneDeep(defaultForm);
                    _.assign(fetched, data);
                    if (fetched.access_token === null) fetched.access_token = '';
                    if (fetched.test_event_code === null) fetched.test_event_code = '';
                    this.form = fetched;
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        async save() {
            const setupStore = useSetupStore();
            const cms = setupStore.activeCms;
            if (!cms) return;

            const payload = _.cloneDeep(this.form);
            payload.cms = { id: cms.id };

            return MetaPixelApi.save(payload).then(data => {
                const saved = _.cloneDeep(defaultForm);
                _.assign(saved, data);
                if (saved.access_token === null) saved.access_token = '';
                if (saved.test_event_code === null) saved.test_event_code = '';
                this.form = saved;
            });
        },
    },
});
